<template>
  <div v-if="show" class="modal">
    <div class="wrapper">
      <div class="modal-dialog" @click.self="onClose">
        <div class="modal-content" :class="[sizeClass]">
          <slot></slot>
          <i v-if="closeIcon" class="material-icons close-icon" @click="onClose">close</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {type: Boolean},
    onClose: {
      type: Function,
      required: true
    },
    closeIcon: {type: Boolean},
    sizeClass: {type: String}
  },
  watch: {
    show: function() {
      const value = this.show ? 'hidden' : ''

      document.body.style.overflow = value
    }
  }
}
</script>

<style lang="sass" scoped>
@import 'raypro_ui/src/styles/base/_variables.sass'

.modal
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 1000
  overflow-y: scroll
  background-color: $overlay-strong

  .wrapper
    display: table
    height: 100%
    width: 100%

  .modal-dialog
    padding: 30px
    display: table-cell
    vertical-align: middle

    .modal-content
      position: relative
      width: inherit
      height: inherit
      margin: 0 auto
      max-width: 750px
      background-color: $color-panel-bg
      overflow: hidden
      border-radius: 5px

      &.size-s
        width: 570px

      .close-icon
        position: absolute
        top: 1rem
        right: 1rem
        font-size: 2.8rem
        color: $color-side-nav
        cursor: pointer
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue